# frozen_string_literal: true

module View
  module Game
  end
end
